"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAgileReminderLimitationCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
function createAgileReminderLimitationCard(survey, reminderLimit, appealConversationId) {
    const message = `Reminders for "${survey.title}" were not sent because there are more than ${reminderLimit} members in the team.`;
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: message,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    if (appealConversationId) {
        card.addAction((0, commands_1.SurveyDeepLinkAction)(survey.tenantId, survey.type, appealConversationId));
    }
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
}
exports.createAgileReminderLimitationCard = createAgileReminderLimitationCard;
//# sourceMappingURL=AgileReminderLimitationCard.js.map